import type { CsvFlowAdapter } from '../../shared/csv/hooks/csvFlowAdapter';
import {
  buildStockCsvExport,
  buildStockCsvTemplate,
  buildStockImportErrorsCsv,
  commitStockCsvImport,
  previewStockCsvImport,
  stockCsvExportFilename,
  stockCsvTemplateFilename,
} from '../stock/public-api';

export function createStockCsvAdapter(
  branchId: string,
  branchLabel: string | undefined,
  performedByUserId: string | null,
): CsvFlowAdapter {
  return {
    buildTemplate: () => buildStockCsvTemplate(),
    templateFilename: () => stockCsvTemplateFilename(),
    buildExport: () => buildStockCsvExport(branchId),
    exportFilename: () => stockCsvExportFilename(branchLabel),
    previewImport: (text) => previewStockCsvImport(branchId, text),
    commitImport: (text) => commitStockCsvImport(branchId, text, { performedByUserId }),
    buildImportErrorsCsv: (errors) => buildStockImportErrorsCsv(errors),
  };
}
